/**
 * Appio collection cards + PDP: correct star fill and fractional averages.
 * - Hydrates data-rating / data-raters from _appioRatings for theme mount points (data-id).
 * - Fixes Appio's Math.ceil(rating*2)/2 rounding (e.g. 4.7 → 5) on .appio-rating-layers.
 */
(function () {
  function parseRating(value) {
    var n = parseFloat(value, 10);
    return isNaN(n) ? null : Math.max(0, Math.min(5, n));
  }

  function lookupRatingEntry(productId, handle) {
    var ratings = window._appioRatings;
    if (!ratings) return null;

    if (handle && ratings[handle]) return ratings[handle];

    if (productId == null) return null;
    var id = String(productId);
    for (var key in ratings) {
      if (!Object.prototype.hasOwnProperty.call(ratings, key)) continue;
      var entry = ratings[key];
      if (entry && String(entry.productId) === id) return entry;
    }
    return null;
  }

  function hydrateBadgeData(badge) {
    if (!badge || badge.getAttribute('data-rating-hydrated') === 'true') return;

    var productId =
      badge.getAttribute('data-id') ||
      badge.getAttribute('data-product-id') ||
      badge.getAttribute('data-pid');
    var handle = badge.getAttribute('data-handle');
    var entry = lookupRatingEntry(productId, handle);

    if (!entry) return;

    var rating = parseRating(entry.rating);
    var raters = entry.raters != null ? String(entry.raters).replace(/[.,]/g, '') : '';

    if (rating != null) {
      badge.setAttribute('data-rating', String(rating));
    }
    if (raters) {
      badge.setAttribute('data-raters', raters);
    }
    if (productId && !badge.getAttribute('data-id')) {
      badge.setAttribute('data-id', productId);
    }
    badge.setAttribute('data-rating-hydrated', 'true');
  }

  function hydrateAllBadges(root) {
    (root || document).querySelectorAll('.appio-rating-badge').forEach(hydrateBadgeData);
  }

  function resetClonedBadges(root) {
    (root || document).querySelectorAll('.is-slider-clone .appio-rating-badge').forEach(function (badge) {
      badge.removeAttribute('rendered');
      badge.removeAttribute('data-rating-hydrated');
      badge.innerHTML = '';
      hydrateBadgeData(badge);
    });
  }

  function resetMinorBadgesForRerender(root) {
    (root || document)
      .querySelectorAll('.appio-rating-badge.appio-rating-minor[rendered]')
      .forEach(function (badge) {
        badge.removeAttribute('rendered');
        badge.removeAttribute('data-rating-hydrated');
        badge.innerHTML = '';
      });
  }

  function ratingForProductId(productId) {
    var entry = lookupRatingEntry(productId, null);
    return entry ? parseRating(entry.rating) : null;
  }

  function ratingForBadge(badge) {
    if (!badge) return null;

    var fromAttr = parseRating(badge.getAttribute('data-rating'));
    if (fromAttr != null) return fromAttr;

    if (badge.classList.contains('appio-rating-major')) {
      if (window._appioRating && window._appioRating.average != null) {
        return parseRating(window._appioRating.average);
      }
      if (typeof meta !== 'undefined' && meta.product && window._appioRatings) {
        var byHandle = window._appioRatings[meta.product.handle];
        if (byHandle && byHandle.rating != null) {
          return parseRating(byHandle.rating);
        }
      }
    }

    return ratingForProductId(
      badge.getAttribute('data-id') ||
        badge.getAttribute('data-product-id') ||
        badge.getAttribute('data-pid')
    );
  }

  function ratingForLayer(layer) {
    var widget = layer.closest('.appio-reviews-widget');
    if (widget && window.Appio && window.Appio.productRating && window.Appio.productRating.average != null) {
      return parseRating(window.Appio.productRating.average);
    }

    var badge = layer.closest('.appio-rating-badge');
    if (badge) return ratingForBadge(badge);

    return null;
  }

  function fixAppioRatingLayers(root) {
    (root || document).querySelectorAll('.appio-rating-layers').forEach(function (layer) {
      var rating = ratingForLayer(layer);
      if (rating == null) return;
      layer.style.setProperty('--appio-rating-value', String(rating));
    });
  }

  function triggerAppioBadgeRender() {
    if (!window.Appio) return;
    if (typeof Appio.checkRatings === 'function') {
      Appio.checkRatings(true);
    } else if (typeof Appio.showRatingBadges === 'function') {
      Appio.showRatingBadges('.appio-rating-badge[data-id]:not([rendered])');
    }
  }

  function runFix(root) {
    resetClonedBadges(root);
    resetMinorBadgesForRerender(root);
    hydrateAllBadges(root);
    triggerAppioBadgeRender();
    fixAppioRatingLayers(root);
    window.setTimeout(function () {
      fixAppioRatingLayers(root);
    }, 1200);
  }

  function whenRatingsReady(cb) {
    if (window._appioRatings) {
      cb();
      return;
    }
    var attempts = 0;
    var timer = window.setInterval(function () {
      if (window._appioRatings || ++attempts > 60) {
        window.clearInterval(timer);
        cb();
      }
    }, 100);
  }

  function scheduleFix(root) {
    whenRatingsReady(function () {
      runFix(root);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      scheduleFix(document);
    });
  } else {
    scheduleFix(document);
  }

  document.addEventListener('appio:collection-ratings-mount', function (event) {
    scheduleFix(event.detail && event.detail.root ? event.detail.root : document);
  });

  if (typeof MutationObserver !== 'undefined') {
    var pending = false;
    var observer = new MutationObserver(function (mutations) {
      var needsFix = false;
      for (var i = 0; i < mutations.length; i++) {
        var m = mutations[i];
        if (m.type === 'childList' && m.addedNodes.length) {
          needsFix = true;
          break;
        }
        if (m.type === 'attributes' && (m.attributeName === 'rendered' || m.attributeName === 'data-rating')) {
          needsFix = true;
          break;
        }
      }
      if (!needsFix) return;
      if (pending) return;
      pending = true;
      requestAnimationFrame(function () {
        pending = false;
        if (window._appioRatings) {
          hydrateAllBadges(document);
          fixAppioRatingLayers(document);
        }
      });
    });
    observer.observe(document.documentElement, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['rendered', 'data-rating'],
    });
  }
})();
